import { ResponseVM } from 'src/app/shared/models/model/concretes/components/response.model';
import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SvgViewerComponent } from 'src/app/shared/components/svg-viewer/svg-viewer.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';

@Component({
  selector: 'app-toggle-question',
  templateUrl: './toggle-question.component.html',
  standalone: true,
  imports: [CommonModule, SvgViewerComponent, SelectButtonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleQuestionComponent),
      multi: true
    }
  ]
})
export class ToggleQuestionComponent implements OnInit, ControlValueAccessor {
  @Input() responses: ResponseVM[] = [];
  @Input() reduced: boolean = false;
  @Input() selectedResponse: ResponseVM | null = null;

  @ViewChildren(SvgViewerComponent) svgViewers!: QueryList<SvgViewerComponent>;

  hoveredItem: ResponseVM | null = null;

  constructor() {}
  onTouched: () => void = () => {};

  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.itemSelected =
        this.responses?.find((response: ResponseVM) => response.value === obj) ||
        ({} as ResponseVM);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngAfterViewInit() {
    if (this.svgViewers && this.svgViewers.length > 0) {
      this.updateSvgColor(this.itemSelected.svg, true);
    }

    let selectedResponse = this.responses?.find(r => r.isSelected && r.isSelected === true);
    if(selectedResponse){
      this.onItemSelected(selectedResponse);
    }
  }

  private onChange: any = () => {};

  ngOnInit() {}

  itemSelected!: ResponseVM;

  onItemSelected(item: ResponseVM) {
    if (this.itemSelected && this.itemSelected !== item) {
      this.updateSvgColor(this.itemSelected.svg, false);
    }

    this.itemSelected = item;
    if (this.itemSelected.svg) {
      this.itemSelected.svg.isActive = true;
    }

    this.updateSvgColor(item.svg, true);

    this.onChange(item['value']);
  }

  setClassActive(item: ResponseVM) {
    return {
      active: this.itemSelected === item,
      hovered: this.hoveredItem === item, // Élément actuellement survolé
      'not-hovered':
        this.hoveredItem !== null && this.hoveredItem !== item && this.itemSelected === item,
      'h-[5.5rem]': item.key.length > 30,
      'h-12': item.key.length <= 30
    };
  }

  mouseEnter(item: any) {
    this.hoveredItem = item;
    const svgViewer = this.findSvgViewer(item.svg);
    if (svgViewer) {
      svgViewer.onMouseEnter();
    }
  }

  mouseLeave(item: any) {
    this.hoveredItem = null;
    if (item.svg != null) this.updateSvgColor(item.svg, item.svg.isActive);
  }

  private updateSvgColor(svg: SvgVM | undefined, isActive: boolean) {
    if (svg) {
      svg.isActive = isActive;
      const svgViewer = this.findSvgViewer(svg);
      if (svgViewer) {
        svgViewer.changeColor();
      }
    }
  }

  private findSvgViewer(svg: SvgVM): SvgViewerComponent | undefined {
    return this.svgViewers.find(viewer => viewer.svg === svg);
  }

  onKeyDown(event: KeyboardEvent, item: any, index: number) {
    const cards = document.querySelectorAll('.clickable-card');

    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.onItemSelected(item);
        break;
    }
  }

  isSelected(item: any): boolean {
    return this.itemSelected === item;
  }
}
